import {connect} from '../../../app/connect';
import {
  getIssueAttributesDefinitionsEntitiesMap,
  getIssueAttributesMappingEntitiesMap,
  getIssueTypesAdminEntitiesMap,
  getIssueTypesAdminIds
} from '../../../app/selectors';
import IssueTypesAdminTable from './IssueTypesAdminTable';

const mapStateToProps = state => ({
  data: getIssueTypesAdminEntitiesMap(state),
  issueTypeIds: getIssueTypesAdminIds(state),
  issueAttributeDefinitions: getIssueAttributesDefinitionsEntitiesMap(state),
  issueAttributeMappings: getIssueAttributesMappingEntitiesMap(state)
});

export default connect(mapStateToProps)(IssueTypesAdminTable);
